import * as React from 'react'

export interface CircularProgressProps { value: number; size?: number; thickness?: number; className?: string }

export function CircularProgress({ value, size = 18, thickness = 3, className }: CircularProgressProps){
  const v = Math.max(0, Math.min(100, Math.round(value || 0)))
  const radius = (size - thickness) / 2
  const circ = 2 * Math.PI * radius
  const dash = (v / 100) * circ
  return (
    <svg width={size} height={size} className={className} viewBox={`0 0 ${size} ${size}`}>
      <circle cx={size/2} cy={size/2} r={radius} stroke="currentColor" strokeOpacity="0.2" strokeWidth={thickness} fill="none" />
      <circle cx={size/2} cy={size/2} r={radius} stroke="currentColor" strokeWidth={thickness} fill="none" strokeDasharray={`${dash} ${circ-dash}`} transform={`rotate(-90 ${size/2} ${size/2})`} />
    </svg>
  )
}

